module.exports = __webpack_public_path__ + "media/images/design/images/icons/instagram-black-2e1a2e09a3e1c3db245a4e7278316454.jpg";